import type { ReactNode } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

interface LayoutProps {
  children: ReactNode;
  overlay?: boolean;
  pushDown?: boolean;
}

export default function Layout({ children, overlay = false, pushDown = true }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-background-100">
      <Navbar overlay={overlay} />
      <main className={`flex-1 w-full ${pushDown ? 'pt-16 md:pt-20' : ''}`}>{children}</main>
      <Footer />
    </div>
  );
}